export var MuiListItemIcon = {
    styleOverrides: {
        root: function () { return ({
            color: "currentcolor",
        }); },
    },
};
